<template>
  <div class="order-wrapper">
    <portal target-el="#filter">
      <Breadcrumb
        :selectedList="selectedList"
        v-on:changeDateRange="search"
        v-on:markUsed="markUsed"
        v-on:downloadWallet="download"/>
    </portal>
    <div>
      <Header
        :disableSelectAll="disableSelectAll"
        v-on:selectAll="selectAll"/>
      <div
        class="fixed-row"
        v-infinite-scroll="loadData"
        infinite-scroll-disabled="loadCheck"
        infinite-scroll-throttle-delay="400"
        infinite-scroll-distance="10">
        <div v-if="isTransporterListLoading && walletList.length === 0">
          <Spinner />
        </div>
        <div v-else-if="walletList.length === 0" class="no-order-data">
          <div class="emptydiv">
            <div class="emptytext"> No Data Found</div>
          </div>
        </div>
        <div v-else>
          <Row v-for="wallet in walletList"
            v-bind:key="wallet.transporter_id"
            :wallet="wallet"
            :value="getValue(wallet)"
            v-on:selectWallet="selectWallet" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from './header';
import Row from './row';
import Breadcrumb from './breadcrumb';
import moment from 'moment';
import { mapGetters } from 'vuex';
import { remove } from 'lodash';

export default {
  components: {
    Breadcrumb,
    Header,
    Row,
  },
  data() {
    return {
      dateRange: null,
      defaultDateRange: `${moment().startOf('month').format('YYYY-MM-DD').trim()}:${moment().endOf('month').format('YYYY-MM-DD').trim()}`,
      loadCheck: true,
      selectedList: [],
    };
  },
  computed: {
    ...mapGetters({
      isTransporterListLoading: 'wallet/isTransporterListLoading',
      walletList: 'wallet/transporterWallet',
      page: 'wallet/page',
      hasEmpty: 'wallet/hasEmpty',
    }),
    disableSelectAll() {
      const list = this.getChangeList();
      return !list.length;
    },
  },

  async created() {
    this.$store.commit('wallet/initData');
    const transporterId = this.$route.params.transporterId;
    this.search();
  },

  methods: {
    search(params) {
      this.$store.commit('wallet/SET_PAGE', 1);
      this.dateRange = params || this.defaultDateRange;
      this.loadData(params);
    },
    async loadData() {
      this.$store.commit('wallet/setDateRange', this.dateRange);
      const transporterId = this.$route.params.transporterId;
      const params = {
        date_range: this.dateRange,
        page: this.page,
      };
      const result = await this.$store.dispatch('wallet/listForTransporters', { transporterId, params });
      if (result.error) {
        this.$errorMessage({ message: result.error });
      }
      this.loadCheck = this.hasEmpty;
    },
    async download() {
      const transporterId = this.$route.params.transporterId;
      const dateRange = this.dateRange;
      try {
        await this.$store.dispatch('wallet/downloadWallet', { transporterId, dateRange });
      } catch (error) {
        this.$error({
          message: error.getMessage() || error.toString(),
        });
      }
    },
    getChangeList() {
      const statusList = [1, 4];
      return this.walletList.filter(wallet => statusList.includes(wallet.status));
    },
    getValue(wallet) {
      if (this.selectedList.includes(wallet.id)) {
        return true;
      }
      return false;
    },
    selectAll(value) {
      if (value) {
        const list = this.getChangeList();
        this.selectedList = list.map(wallet => wallet.id);
      } else {
        this.selectedList = [];
      }
    },
    selectWallet(walletId, value) {
      if (this.selectedList.includes(walletId)) {
        if (!value) {
          remove(this.selectedList, e => e === walletId);
        }
      } else if (value) {
        this.selectedList.push(walletId);
      }
    },
    async markUsed() {
      const hasConfirm = await this.$PromptConfirm('You are sure you want to mark as USED',
        'Confirmation', {
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          lockScroll: true,
          showClose: false,
          center: true,
          dangerouslyUseHTMLString: true,
        });
      if (hasConfirm) {
        const data = {
          wallet_ids: this.selectedList,
        };
        const result = await this.$store.dispatch('wallet/updateUsed', { data });
        if (result) {
          this.selectedList = [];
        }
      }
    },
  },
};
</script>
<style lang='scss'>
.fixed-row {
  position: fixed;
  padding-right: 10px;
  top: 172px;
  left: 20px;
  right: 10px;
  bottom: 0;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>
